// test2434
(2434 && 0);
